import React, { useEffect, useState } from "react";
import { Table, Input, message, ConfigProvider, Popconfirm, Button, Space, Tag, Image } from "antd";
import { SearchOutlined, DeleteOutlined } from "@ant-design/icons";
import "../adminShared/adminPage.css";
import { routes } from "../../api/routes";
import { callApi } from "../../api/apiCaller";
import Loader from "../../components/loader/loader";
import { listFromResponse, isMutationSuccess } from "../../helper/helper";
import dayjs from "dayjs";

const Vehicles = () => {
  const [allRows, setAllRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");

  const load = () => {
    callApi(
      "GET",
      routes.getAllVehicles,
      null,
      setLoading,
      (res) => {
        if (res.status === 200) setAllRows(listFromResponse(res));
      },
      () => message.error("Failed to load vehicles")
    );
  };

  useEffect(() => {
    load();
  }, []);

  const sellerName = (row) =>
    row.seller?.name || row.user?.name || row.owner?.name || row.createdBy?.name || "—";

  const filtered = searchText
    ? allRows.filter((r) => {
        const q = searchText.toLowerCase();
        return (
          (r.registration || "").toLowerCase().includes(q) ||
          (r.make || "").toLowerCase().includes(q) ||
          (r.model || "").toLowerCase().includes(q) ||
          String(sellerName(row)).toLowerCase().includes(q)
        );
      })
    : allRows;

  const remove = (id) => {
    callApi(
      "DELETE",
      `${routes.deleteVehicle}/${id}`,
      null,
      setLoading,
      (res) => {
        if (isMutationSuccess(res)) {
          message.success("Vehicle removed");
          load();
        }
      },
      () => message.error("Failed to delete vehicle")
    );
  };

  const columns = [
    { title: "No", key: "i", width: 55, render: (_, __, i) => i + 1 },
    {
      title: "Image",
      dataIndex: "images",
      key: "images",
      width: 90,
      render: (images) => {
        const src = Array.isArray(images) && images.length ? images[0] : null;
        return src ? (
          <Image src={src} width={56} height={40} style={{ objectFit: "cover", borderRadius: 4 }} />
        ) : (
          "—"
        );
      },
    },
    { title: "Registration", dataIndex: "registration", key: "registration", width: 120 },
    { title: "Make", dataIndex: "make", key: "make", width: 100 },
    { title: "Model", dataIndex: "model", key: "model", width: 100 },
    {
      title: "Variant",
      dataIndex: "modelVariant",
      key: "modelVariant",
      width: 140,
      ellipsis: true,
    },
    { title: "Year", dataIndex: "year", key: "year", width: 72 },
    { title: "Mileage", dataIndex: "mileage", key: "mileage", width: 90 },
    {
      title: "Seller",
      key: "seller",
      width: 140,
      ellipsis: true,
      render: (_, row) => sellerName(row),
    },
    {
      title: "Listed",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 120,
      render: (d) => (d ? dayjs(d).format("DD MMM YYYY") : "—"),
    },
    {
      title: "Action",
      key: "a",
      width: 90,
      fixed: "right",
      render: (_, row) => (
        <Popconfirm title="Remove this listing?" onConfirm={() => remove(row._id)}>
          <Button danger size="small" icon={<DeleteOutlined />} />
        </Popconfirm>
      ),
    },
  ];

  return (
    <ConfigProvider theme={{ token: { colorPrimary: "#555BDF" } }}>
      <div className="admin-entity-page">
        <Loader loading={loading} />
        <div className="admin-entity-header">
          <h1 className="admin-entity-title">Vehicles</h1>
        </div>
        <div className="admin-entity-card">
          <div className="admin-entity-actions">
            <Space>
              <Tag color="processing">Listings ({filtered.length})</Tag>
            </Space>
            <Input
              placeholder="Search registration, make, model, seller…"
              prefix={<SearchOutlined />}
              allowClear
              style={{ maxWidth: 360 }}
              onChange={(e) => setSearchText(e.target.value || "")}
            />
          </div>
          <Table
            className="admin-entity-table"
            rowKey="_id"
            columns={columns}
            dataSource={filtered}
            scroll={{ x: 1200 }}
          />
        </div>
      </div>
    </ConfigProvider>
  );
};

export default Vehicles;
